"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorFeedback = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
// Modules
const react_1 = __importStar(require("react"));
// Components
const flora_react_1 = require("@grupoboticario/flora-react");
// Icons
const Warning_1 = __importDefault(require("@material-ui/icons/Warning"));
const SentimentVeryDissatisfied_1 = __importDefault(require("@material-ui/icons/SentimentVeryDissatisfied"));
const ShoppingBasketOutlined_1 = __importDefault(require("@material-ui/icons/ShoppingBasketOutlined"));
// Styled
const Styled = __importStar(require("./Styled"));
function ErrorFeedback(props) {
    var _a;
    const [heightWrapper, setHeightWrapper] = (0, react_1.useState)(0);
    const testId = `${props.testId}-ErrorFeedback`;
    (0, react_1.useEffect)(() => {
        const headerComp = document.getElementById('global-header');
        const footerComp = document.getElementById('global-footer');
        const header = headerComp ? headerComp.offsetHeight : 48;
        const footer = footerComp ? footerComp.offsetHeight : 80;
        if (props.height) {
            let size = 0;
            if (props.height.header) {
                size += 48;
            }
            if (props.height.title) {
                size += 56;
            }
            if (props.height.navbar) {
                size += 56;
            }
            if (props.height.footer) {
                size += 84;
            }
            setHeightWrapper(size);
        }
        else {
            setHeightWrapper(header + footer);
        }
    }, []);
    const IconSelected = () => {
        switch (props.icon) {
            case 'warning':
                return (0, jsx_runtime_1.jsx)(Warning_1.default, {});
            case 'emoji-down':
                return (0, jsx_runtime_1.jsx)(SentimentVeryDissatisfied_1.default, {});
            case 'shopping-cart':
                return (0, jsx_runtime_1.jsx)(ShoppingBasketOutlined_1.default, {});
            default:
                return (0, jsx_runtime_1.jsx)(react_1.default.Fragment, {});
        }
    };
    return ((0, jsx_runtime_1.jsxs)(Styled.Wrapper, Object.assign({ "data-testid": testId, sizeHeight: `calc(100vh - ${heightWrapper}px)`, small: props.small }, { children: [props.icon && ((0, jsx_runtime_1.jsx)(Styled.Icon, Object.assign({ small: props.small }, { children: (0, jsx_runtime_1.jsx)(IconSelected, {}) }))), props.title && (0, jsx_runtime_1.jsx)(Styled.Title, Object.assign({ small: props.small }, { children: props.title })), (0, jsx_runtime_1.jsx)(Styled.Description, Object.assign({ small: props.small }, { children: props.description })), (0, jsx_runtime_1.jsxs)(Styled.Buttons, { children: [((_a = props.button1) === null || _a === void 0 ? void 0 : _a.actionButton) && ((0, jsx_runtime_1.jsx)(flora_react_1.Button, Object.assign({ onClick: props.button1.actionButton, "data-testid": `${testId}-1-button`, isFull: true, variant: "ghost", rightIcon: props.button1.icon }, { children: props.button1.label }))), props.button2 && props.button2.actionButton && ((0, jsx_runtime_1.jsxs)(react_1.default.Fragment, { children: [(0, jsx_runtime_1.jsx)(Styled.ButtonDivisor, {}), props.button2.actionButton && ((0, jsx_runtime_1.jsx)(flora_react_1.Button, Object.assign({ onClick: props.button2.actionButton, "data-testid": `${testId}-2-button`, isFull: true, variant: "ghost", rightIcon: props.button2.icon }, { children: props.button2.label })))] }))] })] })));
}
exports.ErrorFeedback = ErrorFeedback;
